import { Box, FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react'
import { isNull, isUndefined } from 'lodash'
import { useMemo, type PropsWithChildren, type ReactElement } from 'react'
import { IKReactSelect } from '../../../../../ui-kit'
import type { CMFieldProps } from '.'
import BulkEditModeDropdown from './BulkEditModeDropdown'

const CMBooleanField = ({
  cmField,
  disabled,
  readOnly,
  placeholder,
  isUpload,
  form,
  children,
  labelElement,
  showBulkEditFieldModeDropdown,
  bulkEditFieldMode,
  style,
  required,
  menuPosition,
  setBulkEditFieldMode,
  onInputChange,
}: PropsWithChildren<CMFieldProps>): ReactElement => {
  const shouldShowFormField = useMemo(() => {
    if (!showBulkEditFieldModeDropdown) {
      return true
    }

    return bulkEditFieldMode?.[cmField.name] === 'set'
  }, [bulkEditFieldMode, cmField.name, showBulkEditFieldModeDropdown])
  return (
    <FormControl
      marginBottom={isUpload ? 0 : '30px'}
      isInvalid={Boolean(
        form.errors?.upload &&
          form.touched?.upload &&
          form.errors?.upload[cmField.name] &&
          form.touched?.upload[cmField.name],
      )}
      isRequired={cmField.schema.isValueRequired}
      isDisabled={disabled}
      style={style}
    >
      {labelElement ?? <FormLabel>{cmField.label}</FormLabel>}
      <Box width="100%">
        {showBulkEditFieldModeDropdown &&
          bulkEditFieldMode &&
          setBulkEditFieldMode && (
            <BulkEditModeDropdown
              bulkEditFieldMode={bulkEditFieldMode}
              setBulkEditFieldMode={setBulkEditFieldMode}
              cmField={cmField}
              disabled={readOnly || disabled}
              menuPosition={menuPosition}
              onInputChange={() => {
                onInputChange?.(cmField, form)
              }}
            />
          )}
        {shouldShowFormField && (
          <>
            <IKReactSelect
              variant="compact"
              placeholder={placeholder}
              captureMenuScroll={false}
              menuPlacement="auto"
              isClearable
              isDisabled={readOnly || disabled}
              value={
                isUndefined(form?.values?.upload[cmField.name]) ||
                isNull(form?.values?.upload[cmField.name])
                 ? undefined
                 : {
                     label: String(form?.values?.upload[cmField.name]),
                     value: form?.values?.upload[cmField.name],
                   }
              }
              options={[true, false].map(val => ({
                label: String(val),
                value: val,
              }))}
              onChange={newVal => {
                form.setTouched({ ...form.touched, [cmField.name]: true })
                if (isNull(newVal)) {
                  form.setFieldValue(`upload.['${cmField.name}']`, null)
                } else {
                  form.setFieldValue(`upload.['${cmField.name}']`, Boolean(newVal.value))
                }
                onInputChange?.(cmField, form, newVal ? Boolean(newVal.value) : undefined)
              }}
              required={required}
              menuPosition={menuPosition}
            />
            <FormErrorMessage>
              {form.errors?.upload && form.errors?.upload[cmField.name]}
            </FormErrorMessage>
          </>
        )}
      </Box>
      {children}
    </FormControl>
  )
}

export default CMBooleanField
